// extracted by mini-css-extract-plugin
export default {"bottomNav":"bottomNav_bottomNav__peEnd","badge":"bottomNav_badge__N6yTB"};